import { Home } from "../../pages/Home";

const paths = [{ path: "/", name: "topNavigation.liveMap", Component: Home }];

export default paths;
